import { render } from "./enterBindingModel.vue?vue&type=template&id=a9ba5cdc"
import script from "./enterBindingModel.vue?vue&type=script&lang=js"
export * from "./enterBindingModel.vue?vue&type=script&lang=js"

import "./enterBindingModel.vue?vue&type=style&index=0&id=a9ba5cdc&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__